import React from "react";
import {
  arrayToCurrencyString,
  arrayToCurrencyStringPromo,
  calculateHargaLevel,
} from "../../../utils/currency";
import { findOnePromo } from "../../../utils/promo";
import { useData } from "../../../components/firebase/DataProvider";
import {
  Grid,
  Typography,
  Button,
  Divider,
  // CardActionArea,
} from "@material-ui/core";
// import DeleteIcon from "@material-ui/icons/Delete";
import useStyles from "./style/produkStyle";
import { analytics } from "../../../components/firebase/FirebaseProvider";
import { useHistory } from "react-router-dom";
import slugify from "slugify";
// import Divider from "../../../components/Divider";
import { useSnackbar } from "notistack";
import CopyToClipboard from "react-copy-to-clipboard";

function Products({ product, remove, ...props }) {
  const classes = useStyles();
  const history = useHistory();
  const { level, promo, global_komisi, webstore } = useData();
  const { enqueueSnackbar } = useSnackbar();
  const webstoreProductDiscont = webstore?.products_discount;
  const domain = `https://${webstore.domain}.tokorame.store`;

  const toDetailProduct = (id, title) => () => {
    // console.log("to detail...");
    analytics.logEvent("view_product", { name: title, id: id });

    history.push(`/produk/${slugify(title.toLowerCase())}/${id}`);
  };

  const bagikan = (data) => async () => {
    // setCopied(true);
    // console.log(data);
    // const findProductId = webstore.products?.includes?.(data.id);
    // console.log(findProductId);

    // if (!findProductId) {
    //   await webstoreRef.set(
    //     {
    //       products: FieldValue.arrayUnion(data.id),
    //     },
    //     { merge: true }
    //   );
    // }
    enqueueSnackbar("Link di salin", { variant: "success" });
  };

  return (
    <Grid container className={classes.root} spacing={3}>
      {product.length <= 0 ? (
        <div
          style={{
            // display: "flex",
            justifyContent: "center",
            alignContent: "center",
            width: "100%",
            padding: "20px",
            textAlign: "center",
            marginTop: "5%",
          }}
        >
          <p>
            <b>Produk Kosong</b>
          </p>
          <p>Silahkan Tambah Ke Toko Anda</p>
        </div>
      ) : (
        <>
          {product.map((item, index) => {
            const stok = item.variants.map((variant) => variant.stok_available);

            const productValue =
              item?.product_value !== undefined &&
              item?.product_value !== "" &&
              !Number.isNaN(item?.product_value) &&
              item?.product_value >= 0
                ? item?.product_value
                : 1;

            const harga = item.variants.map((variant) =>
              calculateHargaLevel(
                variant?.harga_normal,
                global_komisi,
                level?.level,
                productValue
              )
            );

            const harga_normal = item.variants.map(
              (variant) => variant?.harga_normal
            );

            const promoFound = findOnePromo(item, promo);

            const total_stok = stok.reduce((val, nilaiSekarang) => {
              return val + nilaiSekarang;
            }, 0);

            const emptyStock = total_stok === 0 ? true : false;

            const harga_str = arrayToCurrencyString(harga);
            const promoF = promoFound ? true : false;

            const harga_str_promo =
              promoFound &&
              arrayToCurrencyStringPromo(
                harga_normal,
                promoFound,
                level.level,
                global_komisi,
                productValue
              );

            return (
              <>
                <div
                  style={{
                    width: "100%",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                    paddingTop: "5px",
                    paddingBottom: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      // justifyContent: "space-between",
                      width: "100%",
                      borderRadius: 8,
                      // marginBottom: "5px",
                      paddingBottom: "10px",
                      backgroundColor: "white",
                    }}
                    onClick={toDetailProduct(item.id, item.nama)}
                  >
                    <div
                      style={{
                        display: "flex",
                        // marginLeft: "1.5%",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          style={{
                            width: 75,
                            height: 75,
                            marginRight: "10px",
                            borderRadius: 4,
                          }}
                          src={item?.thumbnail?.[0]}
                          alt="logo"
                        />
                      </div>
                      <div style={{ marginLeft: "1.5%" }}>
                        <div>
                          <Typography
                            color="primary"
                            style={{ fontSize: 12, marginBottom: "5px" }}
                          >
                            Produk Tersedia ditoko
                          </Typography>
                        </div>

                        <div style={{ display: "flex" }}>
                          <div style={{ display: "inline-grid" }}>
                            <Typography
                              noWrap={true}
                              style={{
                                fontSize: 13,
                                fontWeight: "bold",
                                textTransform: "capitalize",
                              }}
                            >
                              {item?.nama}
                            </Typography>
                          </div>
                        </div>
                        <div>
                          <Typography style={{ fontSize: 13 }}>
                            {harga_str}
                          </Typography>
                        </div>
                        <div style={{ display: "inline-grid" }}>
                          <Typography noWrap style={{ fontSize: 12 }}>
                            {item?.properties?.type === "preorder" ? "" : `stok: ${total_stok}`}
                            {webstoreProductDiscont?.[item?.id]?.nilai ? (
                              <div className={classes.labelKomisi}>
                                Diskon Toko{" "}
                                {webstoreProductDiscont?.[item?.id]?.nilai}%
                              </div>
                            ) : null}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "10px",
                      justifyContent: "center",
                    }}
                  >
                    <div style={{ marginRight: "10px", width: "100%" }}>
                      <Button
                        style={{ color: "black" }}
                        fullWidth
                        variant="outlined"
                        // color="primary"
                        size="small"
                        onClick={() => remove(index)(item.id)}
                      >
                        <Typography
                          noWrap
                          style={{
                            textTransform: "capitalize",
                            fontSize: 12,
                            fontWeight: "bold",
                            color: "gray",
                          }}
                          variant="button"
                        >
                          Hapus Produk
                        </Typography>
                      </Button>
                    </div>
                    <div style={{ marginRight: "10px", width: "100%" }}>
                      <CopyToClipboard
                        text={`${domain}/produk/${slugify(
                          item?.nama?.toLowerCase()
                        )}/${item?.id}`}
                        onCopy={bagikan(item)}
                      >
                        <Button
                          style={{ color: "black" }}
                          fullWidth
                          variant="outlined"
                          // color="primary"
                          size="small"
                          // onClick={bagikan(item)}
                        >
                          <Typography
                            noWrap
                            style={{
                              textTransform: "capitalize",
                              fontSize: 12,
                              fontWeight: "bold",
                              color: "gray",
                            }}
                            variant="button"
                          >
                            Bagikan Produk
                          </Typography>{" "}
                        </Button>
                      </CopyToClipboard>
                    </div>
                  </div>
                  <Divider
                    style={{ marginTop: "24px", marginBottom: "24px" }}
                  />
                </div>
              </>
            );
          })}
        </>
      )}
    </Grid>
  );
}

export default Products;
